/**
 * Freemium plan helpers (v1.5.0).
 *
 * The backend computes `plan_tier` ("free" | "pro") on every /auth/me and
 * /billing/status response. Components gate Pro features through
 * `useCanAccess()` so the tier logic lives in exactly one place.
 *
 * FREE:  1 vessel · unlimited entries in all categories · photos ·
 *        cruiser contacts · maintenance status colors
 * PRO:   unlimited vessels · co-captains · AI extraction (receipt OCR,
 *        survey, parts import) · charts & fuel-economy analytics ·
 *        checklists · SMS alerts · custom fields · PDF export
 */
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isNativeApp } from "@/lib/platform";
import { openPaywall } from "@/lib/iap";

export function isProUser(user) {
    return user?.plan_tier === "pro";
}

/** Route the captain to the right upgrade surface for their platform:
 *  web → /pricing (Stripe) · iOS/Android native → RevenueCat paywall. */
export function goUpgrade(nav) {
    if (isNativeApp()) {
        openPaywall();
    } else if (nav) {
        nav("/pricing");
    } else {
        window.location.href = "/pricing";
    }
}

/** Hook: `const { isPro, tier, upgrade } = useCanAccess();` */
export function useCanAccess() {
    const { user } = useAuth();
    const nav = useNavigate();
    const isPro = isProUser(user);
    return {
        isPro,
        tier: isPro ? "pro" : "free",
        upgrade: () => goUpgrade(nav),
    };
}
